import * as React from 'react'

function SvgAm(props) {
	return (
		<svg viewBox="0 0 1200 600" width="1em" height="1em" {...props}>
			<path fill="#F2A800" d="M0 0h1200v600H0z" />
			<path fill="#0033A0" d="M0 0h1200v400H0z" />
			<path fill="#D90012" d="M0 0h1200v200H0z" />
		</svg>
	)
}

export default SvgAm
